import React from 'react';
import { Eye, Loader2 } from 'lucide-react';
import { twMerge } from 'tailwind-merge';

interface EyeButtonProps {
  onClick?: () => void;
  outerClassName?: string;
  innerClassName?: string;
  ariaLabel?: string;
  loading?: boolean;
  disabled?: boolean;
}

const EyeButton: React.FC<EyeButtonProps> = ({
  onClick,
  ariaLabel,
  outerClassName,
  innerClassName,
  loading = false,
  disabled = false,
}) => {
  return (
    <button
      type="button"
      className={twMerge(
        'flex items-center justify-center h-7 w-7 rounded-full border border-primary  bg-white hover:bg-gray-100 flex-shrink-0 min-w-fit min-h-fit disabled:cursor-not-allowed disabled:opacity-50',
        outerClassName
      )}
      aria-label={ariaLabel ?? 'Show details'}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading ? (
        <Loader2 className={twMerge('h-4 w-4 text-primary animate-spin', innerClassName)} />
      ) : (
        <Eye className={twMerge('h-4 w-4 text-primary', innerClassName)} />
      )}
    </button>
  );
};

export default EyeButton;
